// PMS.V2.8 · Phase 1B — single source of truth for Management Authorisation
// USER-FACING terminology. DISPLAY MAPPING ONLY — never mutate API payloads or
// stored approval_status values through this helper. Backend contract
// (approval_status: Not Submitted / Pending Approval / Authorized / Rejected,
// ESO auth_status: PendingApproval / Authorised) is preserved untouched.

export const AUTH_ACTION = {
  saveDraft: "Save as Draft",
  submit: "Submit for Authorisation",
  resubmit: "Resubmit for Authorisation",
  reauthorise: "Submit for Re-authorisation",
  authorise: "Authorise",
  reject: "Reject",
  cancel: "Cancel",
  queue: "Management Authorisation Queue",
};

// Canonical British display labels keyed by the lower-cased stored value.
const STATUS_DISPLAY = {
  "": "Draft",
  "not submitted": "Draft",
  "draft": "Draft",
  "pending approval": "Pending Authorisation",
  "pendingapproval": "Pending Authorisation",
  "pending authorisation": "Pending Authorisation",
  "pending authorization": "Pending Authorisation",
  "authorized": "Authorised",
  "authorised": "Authorised",
  "approved": "Authorised",
  "rejected": "Rejected",
  "cancellation pending approval": "Cancellation Pending Authorisation",
  "cancelled": "Cancelled",
  "invalidated": "Invalidated",
};

// Map a raw stored approval/auth value to its canonical British display label.
export function authStatusLabel(raw) {
  const key = String(raw ?? "").trim().toLowerCase();
  if (key in STATUS_DISPLAY) return STATUS_DISPLAY[key];
  return raw || "Draft";
}
